<nb-card class="own-scroll">
  <nb-card-header
    >{{ header }}
    <button
      class="cancel"
      nbButton
      outline
      status="info"
      size="small"
      (click)="cancel()"
    >
      <nb-icon icon="close-outline"></nb-icon></button
  ></nb-card-header>
  <nb-card-body>
    <div class="form-inline">
      <nb-form-field fullWidth>
        <input
          type="text"
          nbInput
          fullWidth
          class="form-control"
          placeholder="Tìm theo tên"
          [(ngModel)]="strSearch"
          (change)="onSearch()"
        />
        <button
          nbSuffix
          nbButton
          ghost
          shape="semi-round"
          nbTooltip="Tra cứu"
          (click)="search()"
        >
          <nb-icon icon="search-outline"> </nb-icon>
        </button>
      </nb-form-field>
    </div>
    <nb-list>
      <nb-list-item *ngFor="let item of displays" class="contact">
        <div>
          <h6 *ngIf="item.title">
            <a class="link" (click)="testQuiz(item.id)">
              <nb-icon
                *ngIf="item.type === 'radio'"
                icon="checkmark-circle-outline"
              ></nb-icon>
              <nb-icon
                *ngIf="item.type === 'check'"
                icon="checkmark-square-outline"
              ></nb-icon>
              <nb-icon
                *ngIf="item.type === 'input'"
                icon="file-outline"
              ></nb-icon>
              <nb-icon
                *ngIf="item.type === 'document'"
                icon="file-text-outline"
              ></nb-icon>
              {{ item.title }}
            </a>
          </h6>
        </div>

        <button
          nbButton
          shape="round"
          outline
          status="success"
          size="small"
          [disabled]="submitted"
          [class.btn-pulse]="submitted"
          (click)="selected(item)"
        >
          <nb-icon icon="checkmark-outline"></nb-icon>
        </button>
      </nb-list-item>
    </nb-list>
  </nb-card-body>
  <nb-card-footer> </nb-card-footer>
</nb-card>
